<template>
  <el-dialog class="publishWrapper" title="支付任务包金额" :visible.sync="payDialogVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" @close="payCancle" width="30%" center>
    <div class="moneyEnWrapper" v-if="cashaccount >= currentItem.packageMoney">
      <div class="body">
        <div class="divpubWrapper">
          <div class="name">任务包名称：</div>
          {{ currentItem.name }}
        </div>
        <div class="divpubWrapper">
          <div class="name">类型：</div>
          <span v-if="currentItem.inostype =='1'">整包</span>
          <span v-else>{{ dictShow(currentItem.type, packageTypeArr) }}</span>
        </div>
        <div class="divpubWrapper">
          <div class="name">金额：</div>
          <div style="color: red; text-align: left">
            {{ currentItem.packageMoney.toFixed(2) }}元
          </div>
        </div>
        <div class="codeForm">
          <div class="divpubWrapper">
            <div class="name">手机号码：</div>
            {{ telNum }}
          </div>
          <div class="name">验证码</div>
          <div class="verify-wrapper">
            <el-input type="text" maxlength="6" placeholder="请输入短信验证码" v-model="code" @blur="checkCode()" />
            <el-button style="position: absolute; right: 5px" type="text" class="btn-orange" :disabled="disabled" @click="getCode">{{ valiBtn }} </el-button>
          </div>
          <div class="codeTips">
            <div v-show="noCode">请输入验证码</div>
            <div v-show="errCode">您输入的验证码不正确</div>
          </div>
        </div>
        <div class="payPasswordWrapper">
          <div class="name" style="text-align: left">请输入支付密码</div>

          <div :class="psweidt == true ? 'curEdit pwipt' : 'pwipt'" @click="test">
            <input type="password" @input="judgePassword" v-model="password" autofocus maxlength="6" />
            <div class="border-right">
              <span v-if="show1"></span>
            </div>
            <div class="border-right">
              <span v-if="show2"></span>
            </div>
            <div class="border-right">
              <span v-if="show3"></span>
            </div>
            <div class="border-right">
              <span v-if="show4"></span>
            </div>
            <div class="border-right">
              <span v-if="show5"></span>
            </div>
            <div>
              <span v-if="show6"></span>
            </div>
          </div>
        </div>
        <div class="pswWrapper">
          <el-button type="text" @click="toSetPwd">设置支付密码</el-button><el-button type="text"
            @click="toSetPwd">忘记支付密码</el-button>
        </div>
        <div slot="footer" class="checkWrapper dialog-footer" style="text-align: center">
          <el-button type="primary" @click="haddlePublish" :loading="zfloading"> {{ zfloading ? '支付中' : '确认支付'}}</el-button>
        </div>
      </div>
      <p class="desWrapper">
        将从您的账户余额中扣取<span class="redtxt">{{ currentItem.packageMoney.toFixed(2) }}元</span>作为保证金，在项目验收通过后，保证金自动结算给接包方。
      </p>
    </div>
    <div class="moneyUnEnWrappere" v-if="cashaccount < currentItem.packageMoney">
      <p>
        您的账户余额不足，<el-button type="text" @click="toRechange">马上去充值</el-button>
      </p>
    </div>
  </el-dialog>
</template>
<script>
import { AssetInfoEmp, issuingPartyInfo } from "@/api/employer/user/user";
import { packageType } from "@/api/common";
import {checkCode,packagePublish,getCode,setPublish} from "@/api/employer/project/project";
export default {
  name: 'releaseup',
  props: {
    releaseinfo: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      payDialogVisible: false, // 弹窗开关
      cashaccount: 0, // 账户金额信息
      telNum:null, // 手机号码
      currentItem: {}, // 包信息对象
      packageTypeArr: [], //包类型数组 :1整包 2分包
      code: "", // 验证码
      disabled: false, // 是否能够获取验证码
      psweidt: false, // 密码输入框是否进入样式
      valiBtn: "获取验证码", // 获取验证码 字样
      zfloading:false, // 点击支付时的loading
      noCode: false, // 校验验证码是否正确
      errCode: false, //  您输入的验证码不正确
      password: null, // 输入的密码
      show1: false,  // 输入框圈点1
      show2: false,  // 输入框圈点2
      show3: false,  // 输入框圈点3
      show4: false,  // 输入框圈点4
      show5: false,  // 输入框圈点5
      show6: false,  // 输入框圈点6
    };
  },
  created () {
    this.initFormPick(); // 默认进入初始化
    this.getAssetInfoEmp();  //获取账户信息
    this.getIssuingPartyInfo(); // 获取详情 --手机号
    this.getPackageType(); // 获取包类型
  },
  methods: {
    // 初始化
    initFormPick () {
      if(this.releaseinfo.packageMoney){
        this.payDialogVisible = true; // 打开弹窗
        this.currentItem = this.releaseinfo;
      }else{
        this.$message.error('缺少主要参数哦～');
      }
    },
    // 这个是数据清空 返回
    payCancle() {
      this.code = '';
      this.payDialogVisible = false;
      this.password = "";
      this.psweidt = false;
      this.judgePassword();
      this.$emit('close', this.$options._componentTag);
    },

    /*获取账户信息*/
    getAssetInfoEmp() {
      AssetInfoEmp().then((res) => {
        this.cashaccount = res.data.cashaccount;
      });
    },

    /*获取详情 --手机号*/
    getIssuingPartyInfo() {
      issuingPartyInfo().then((res) => {
        this.telNum = res.data.phoneNumber;
      });
    },
    // 获取包类型
    getPackageType() {
      packageType().then((res) => {
        this.packageTypeArr = res.data;
      });
    },
    // 支付
    haddlePublish() {
      if (!this.errCode && this.code) {
        var data = {
          id: this.currentItem.id,
          password: this.password,
        };
        if (this.password != "" && this.password != null) {
          this.zfloading = true;

          if(this.currentItem.inostype =='1'){
            setPublish(data).then((res) => {
              this.code = '';
              this.payDialogVisible = false;
              this.psweidt = false;
              this.$emit('ok');
              this.zfloading = false;
            }).catch((response) => {
              this.zfloading = false;
            });;
          }else{
            packagePublish(data).then((res) => {
              this.code = '';
              this.payDialogVisible = false;
              this.psweidt = false;
              this.$emit('ok');
              this.zfloading = false;
            }).catch((response) => {
              this.zfloading = false;
            });;
          }
        } else {
          this.$message.warning("请先填写支付密码！");
        }
      } else {
        if (this.errCode) {
          this.$message.error("请输入正确验证码！");
        } else {
          this.noCode = true;
          this.$message.error("请先填写验证码！");
        }
      }
    },

    // 校验验证码
    checkCode() {
      let that = this;
      let phone = that.telNum;
      let codee = that.code;
      if (that.code) {
        checkCode(phone, codee)
          .then((res) => {
            if (res.code == 200) {
              that.$message({
                type: "success",
                message: "验证码校验通过!",
              });
              that.errCode = false;
              that.noCode = false;
            }
          })
          .catch((err) => {
            if (err.code != 200) {
              that.errCode = true;
              that.noCode = false;
            }
          });
      } else {
        that.noCode = true;
        that.errCode = false;
      }
    },
    //获取验证码 并只验证手机号 是否正确
    getCode() {
      var that = this;
      this.tackBtn(); //验证码倒数60秒
      var phone = that.telNum;
      getCode(phone).then(function (res) {
        if (res.code == 200) {
          that.$message({
            type: "success",
            message: "验证码已发送!",
          });
        } else {
          that.$message.error(res.msg);
          return false;
        }
      });
    },
    // 验证码倒数60秒
    tackBtn() {
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    },

    // 密码输入样式
    judgePassword() {
      if (this.password == "") {
        this.psweidt = false;
      } else {
        this.psweidt = true;
      }
      if (this.password.length == 0) {
        this.show1 = false;
        this.show2 = false;
        this.show3 = false;
        this.show4 = false;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 1) {
        this.show1 = true;
        this.show2 = false;
        this.show3 = false;
        this.show4 = false;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 2) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = false;
        this.show4 = false;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 3) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = false;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 4) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = false;
        this.show6 = false;
      }
      if (this.password.length == 5) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = true;
        this.show6 = false;
      }
      if (this.password.length == 6) {
        this.show1 = true;
        this.show2 = true;
        this.show3 = true;
        this.show4 = true;
        this.show5 = true;
        this.show6 = true;
      }
    },
    /*金额框自己获焦*/
    changInput(refName) {
      this.$refs[refName].focus();
    },

    /*去充值*/
    toRechange() {
      let routeData = this.$router.resolve({ path: '/empUser/empAccountIndex/empRecharge'});
      window.open(routeData.href, '_blank');
      // this.$router.push("/empUser/empAccountIndex/empRecharge");
    },
    /*去设置密码 忘记支付密码*/
    toSetPwd() {
      this.$router.push("/empUser/empSet/Paythepasswordtwo");
    },
    // 点击密码输入框事件
    test() {
      this.psweidt = true;
    },
     /*字典字段显示*/
     dictShow(value, option) {
      if (value == null && value == undefined && value == "") {
        var temp = "";
        return temp;
       } else {
        var resArr = option.find((item) => item.dictValue == value);
        return resArr.dictLabel;
      }
    },

  }
};
</script>



<style scoped>
/deep/.publishWrapper .el-dialog--center .el-dialog__body {
  padding-bottom: 0px;
}

/deep/.publishWrapper .el-dialog--center .el-dialog__footer {
  padding-bottom: 30px;
}

.moneyEnWrapper {
  text-align: center;
  padding-bottom: 40px;
}

.moneyEnWrapper .body {
  width: 280px;
  margin: 0 auto;
  text-align: left;
}

.divpubWrapper {
  /* text-align: center; */
  /* display: flex; */
  padding: 8px 0;
}

.divpubWrapper .name {
  color: #999;
  font-size: 16px;
}

.verify-wrapper {
  position: relative;
  margin: 10px auto;
  width: 280px;
}

.codeTips {
  color: red;
  width: 280px;
  margin: 0px auto;
  text-align: left;
}

.payPasswordWrapper {
  border: none;
  text-align: center;
}

.payPasswordWrapper .el-input {
  width: 46px;
  border: none;
}

.pwipt {
  border-radius: 6px;
  font-size: 0;
  height: 45px;
  line-height: 45px;
  width: 280px;
  background: #fff;
  margin: 0 auto;
  border: 1px solid #ccc;
}

.pwipt div {
  display: inline-block;
  width: 16.2%;
  height: 45px;
  position: relative;
}

.pwipt .border-right {
  border-right: 1px solid #ccc;
}

.pwipt div>span {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #000;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  margin-top: -5px;
  margin-left: -5px;
}

.pwipt input {
  outline: none;
  border: 0;
  background: none;
  width: 100%;
  height: 45px;
  padding: 12px 0;
  text-align: center;
  position: absolute;
  /* left: -500px; */
  right: 0;
  z-index: 1000;
  color: transparent;
  text-indent: -999em;
}

.curEdit.pwipt {
  border: 1px solid #22ab45 !important;
}

.pswWrapper {
  width: 300px;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
}

.checkWrapper {
  margin-top: 32px;
  text-align: left;
}

.checkWrapper .el-select {
  margin-left: 4px;
}

.checkWrapper .el-input {
  margin-left: 4px;
}

.checkWrapper .el-button--primary {
  background: #f9bd00;
  border: 1px solid #f9bd00;
  color: #333333;
}

.checkWrapper .el-button--primary:hover {
  background: #fac009;
  border: 1px solid #fac009;
}

.desWrapper {
  width: 60%;
  margin: 20px auto;
}

.moneyUnEnWrappere p {
  text-align: center;
  padding-bottom: 60px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/releaseUp/release.vue